import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const HydrochloricAcidPage = () => {

    const productData = {
        description: [
            "Hydrochloric Acid (HCl) is a strong, clear inorganic acid offered in industrial concentrations (commonly 30–38% w/w). It is an essential process chemical used across metal treatment, pH control, chemical manufacturing, and water treatment.",
            "Supplied in drums and tanker loads with proper corrosion-resistant packaging and full safety documentation.",
            "• Drums (ISO / export drums): typically 200 L carbon-steel drums with acid-resistant lining, or HDPE-lined steel drums for corrosive liquids — useful for small to medium orders.",
            "• Intermediate Bulk Containers (IBC): for intermediate quantities where compatible liners are used.",
            "• Tanker / Road tanker (Tank truck): for bulk deliveries (several tons). Tankers must have corrosion-resistant linings and grounding provisions.",
            "• ISO tank containers / tank containers: for international transport in bulk.",
            "• Packing & labeling: all packages supplied with SDS, UN/DOT hazard labeling, and tamper-evident seals. Customers can choose drum or tanker loading depending on order size and onsite storage capability."
        ],
        applications: [
            {
                id: 1,
                title: "Steel Pickling",
                description: "Hydrochloric Acid is widely used in the pickling of steel and ferrous metals. During hot-rolling and storage, steel develops oxide scale (iron oxides) that interferes with downstream processes like galvanizing, welding, and cold forming..",
                image: "/images/products/hydrochloric-acid/steel.jpg"
            },
            {
                id: 2,
                title: "pH Control & Neutralization",
                description: "Hydrochloric Acid is a commonly preferred acid for pH adjustment because it provides high acidity, predictable neutralization behavior, and low contamination of the water being treated.",
                image: "/images/products/hydrochloric-acid/pH-Control.jpg"
            },
            {
                id: 3,
                title: "Production of Inorganic & Organic Chemicals",
                description: "Hydrochloric Acid is a crucial raw material and reagent in chemical manufacturing. It is used to produce a wide range of inorganic salts and organic intermediates.",
                image: "/images/products/hydrochloric-acid/production-of.jpg"
            },
            {
                id: 4,
                title: "Regeneration of Ion-Exchange Resins",
                description: "Ion-exchange resins are used in water softening and deionization systems to remove hardness ions (calcium, magnesium) and dissolved salts. Over time, the resin beads become 'exhausted' and lose efficiency.",
                image: "/images/products/hydrochloric-acid/regenerationofion.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.hydrochloricAcid.title} description={seoData.hydrochloricAcid.description} keywords={seoData.hydrochloricAcid.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Hydrochloric Acid" pagesub="Hydrochloric Acid" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/hydrochloric-acid/hydrochloric-acid.png' alt="Hydrochloric Acid" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/hydrochloric-acid/hydro1.jpg' alt="Hydrochloric Acid Packaging" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/hydrochloric-acid/hydro2.jpg' alt="Hydrochloric Acid Storage" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Hydrochloric Acid (HCl)</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>HCl</span></li>
                                        <li>Purity: <span>30-36%</span></li>
                                        <li>Grade: <span>Industrial/Technical</span></li>
                                        <li>Packaging: <span>25L, 50L, 200L Drums</span></li>
                                        <li>CAS Number: <span>7647-01-0</span></li>
                                        <li>Molecular Weight: <span>36.46 g/mol</span></li>
                                        <li>pH Level: <span>Highly Acidic</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />

                </div>
            </div>
            {/* <TwoColumnSection /> */}
            {/* <div className="team-pg-area section-padding">
                <div className="container">
                    <div className="exprience-area">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="wpo-contact-area ex-wiget">
                                    <h2>Request Quote</h2>
                                    <div className="quote-form">
                                        <form onSubmit={SubmitHandler}>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder="Name:" name="name" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="email" className="form-control" placeholder="Email:" name="email" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder="Company:" name="company" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder="Quantity Required:" name="quantity" />
                                            </div>
                                            <div className="form-group full-col">
                                                <textarea className="form-control" name="requirements" placeholder="Specific Requirements..."></textarea>
                                            </div>
                                            <div className="form-group full-col">
                                                <button className="btn theme-btn" type="submit" disabled={loading}>
                                                    {loading ? 'Submitting...' : 'Request Quote'}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <Footer/>
            <Scrollbar />
        </Fragment>
    )
};
export default HydrochloricAcidPage;